module.exports = __webpack_public_path__ + "img/share.0ac92588.svg";